<!-- Card -->
<section class="card">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'general.general' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div class="card-body">
    <configuration-option-form
      (onPatch)="onSubmit($event)"
      [configurationOption]="configurationOption$ | async"
    >
    </configuration-option-form>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
